module.exports = __webpack_public_path__ + "static/media/galerija_2019 (44).7e25cf69.jpg";